import React from "react";
import { CircularProgress, Divider, List, ListItemButton } from "@mui/material";
import { KeyboardArrowRight, Logout } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useQuery, useQueryClient } from "react-query";
import { profileFn } from "../../Services/Authentication/Profile/UserProfile";
import { profileItems } from "../../Mock";

const Profile = () => {
  const navigate = useNavigate();
  const client = useQueryClient();
  const { data: profile, isLoading } = useQuery(
    ["profile"],
    () => profileFn(),
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
    }
  );
  const handleLogout = () => {
    localStorage.clear();
    navigate("/");
    client.refetchQueries("cartList");
    client.refetchQueries("myWishList");
  };

  const userProfile = profile?.data?.data?.profile_data?.[0];
  return (
    <div className="flex flex-col w-full pb-16">
      <div className="p-4">
        <p className="text-xl">My Account </p>
      </div>
      <Divider />
      {isLoading ? (
        <div
          className="flex h-60 flex-col
         items-center justify-center"
        >
          <CircularProgress />
        </div>
      ) : (
        <div className="flex h-60 flex-col gap-5 items-center justify-center">
          <img
            src={userProfile?.profile_picture}
            alt=""
            className="rounded-full h-20"
          />
          <span className="flex flex-col items-center gap-1">
            <p className="font-semibold text-xl">
              {userProfile?.first_name + " " + userProfile?.last_name}
            </p>

            <p>{userProfile?.mobile_no}</p>
            <p>{userProfile?.email}</p>
          </span>
        </div>
      )}

      <Divider />
      <List>
        {profileItems?.map((item, index) => {
          return (
            <React.Fragment key={index + 1}>
              <ListItemButton
                className="!p-4"
                onClick={() => navigate(item.path)}
              >
                <span className="flex justify-between items-center w-full">
                  <span className="flex items-center gap-3">
                    {item.icon}
                    <p> {item.titile}</p>
                  </span>
                  <KeyboardArrowRight />
                </span>
              </ListItemButton>
              <Divider />
            </React.Fragment>
          );
        })}
        <ListItemButton className="!p-4" onClick={handleLogout}>
          <span className="flex justify-between items-center w-full">
            <span className="flex items-center gap-3">
              <Logout />
              <p> Logout</p>
            </span>
          </span>
        </ListItemButton>
      </List>
    </div>
  );
};

export default Profile;
